// extracted by mini-css-extract-plugin
module.exports = {"paymentDescription":"_146kMOBdl6a_fuYozGL8Xx"};